module.exports = __webpack_public_path__ + "static/media/logo.e7abfa69.svg";